<template>
  <v-container fluid class="main-container" style="text-align: center;">
    <PageHeader
      header="View X-ray Submissions"
      :subheader="activeService.name || 'No service selected'"
    />

    <v-select
      :items="itemFilters"
      v-model="submissionFilter"
      @change="filterChanged"
      class="mt-10"
      label="Filter submissions"
      style="margin: auto; max-width: 320px;"
    ></v-select>

    <v-data-table :headers="headers" :items="filteredItems"></v-data-table>
  </v-container>
</template>

<script>
import {
  GetActiveOffsiteService,
  FILTER_ALL,
  FILTER_COMPLETE,
  FILTER_INCOMPLETE,
  XRAY
} from "@/store/offsiteService";
import { ConsolidateMapSubmission } from "@/store/xray";

import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "ViewSubmissions",

  components: {
    PageHeader
  },

  data: () => ({
    activeService: { id: null, name: null },
    headers: [
      { text: "Name", value: "name" },
      { text: "User Code", value: "userCode" },
      { text: "X-ray", value: "xray" }
    ],
    items: [],
    itemFilters: [FILTER_ALL, FILTER_COMPLETE, FILTER_INCOMPLETE],
    filteredItems: [],
    sampleCode: "",
    submissionFilter: FILTER_ALL
  }),

  mounted() {
    this.activeService = GetActiveOffsiteService();

    ConsolidateMapSubmission(this.activeService.id).then(submissionMap => {
      for (const key in submissionMap) {
        const value = submissionMap[key];
        this.items.push({
          name: value["name"] || "",
          userCode: key || "",
          xray: value[XRAY] ? "DONE" : ""
        });
      }

      this.filteredItems = [...this.items];
    });
  },

  methods: {
    filterChanged() {
      if (FILTER_ALL === this.submissionFilter) {
        this.filteredItems = [...this.items];
      } else if (FILTER_COMPLETE === this.submissionFilter) {
        this.filteredItems = this.items.filter(doc => doc.xray);
      } else if (FILTER_INCOMPLETE === this.submissionFilter) {
        this.filteredItems = this.items.filter(doc => !doc.xray);
      }
    }
  }
};
</script>
